import React, { useState, useEffect } from 'react';

const ROICalculator = () => {
  const [budget, setBudget] = useState(2500);
  const [targetAudience, setTargetAudience] = useState('young-professionals');
  const [monthlyReach, setMonthlyReach] = useState(125);
  const [roiPercentage, setRoiPercentage] = useState(340);

  const calculateROI = () => {
    const audienceMultipliers = {
      'young-professionals': 1.2,
      'families': 1.0,
      'students': 0.8,
      'seniors': 0.9
    };

    const baseReachPerDollar = 50; // 50 people per dollar
    const baseROI = 14; // 14% base ROI

    const multiplier = audienceMultipliers[targetAudience] || 1.0;
    const reach = Math.round((budget * baseReachPerDollar * multiplier) / 1000);
    const roi = Math.round(budget * baseROI * multiplier / 100);

    setMonthlyReach(reach);
    setRoiPercentage(roi);
  };

  useEffect(() => {
    calculateROI();
  }, [budget, targetAudience]);

  return (
    <div className="bg-white rounded-xl p-6 mb-6 shadow-sm">
      <h4 className="text-lg font-semibold text-text-primary mb-4">ROI Calculator</h4>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-text-secondary mb-2">Monthly Budget</label>
          <input 
            type="range" 
            min="500" 
            max="10000" 
            value={budget}
            onChange={(e) => setBudget(parseInt(e.target.value))}
            className="w-full" 
          />
          <div className="flex justify-between text-sm text-text-secondary">
            <span>₹5000</span>
            <span>₹{budget.toLocaleString()}</span>
            <span>₹1,00,000</span>
          </div>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-text-secondary mb-2">Target Audience</label>
          <select 
            value={targetAudience}
            onChange={(e) => setTargetAudience(e.target.value)}
            className="w-full p-3 border border-border rounded-lg focus:border-primary focus:outline-none"
          >
            <option value="young-professionals">Young Professionals (25-35)</option>
            <option value="families">Families (30-45)</option>
            <option value="students">Students (18-25)</option>
            <option value="seniors">Seniors (55+)</option>
          </select>
        </div>
      </div>
      
      <div className="mt-6 grid grid-cols-2 gap-4">
        <div className="p-4 bg-primary/10 rounded-lg text-center">
          <div className="text-2xl font-bold text-primary">{monthlyReach}K</div>
          <div className="text-sm text-text-secondary">Monthly Reach</div>
        </div>
        <div className="p-4 bg-success/10 rounded-lg text-center">
          <div className="text-2xl font-bold text-success">{roiPercentage}%</div>
          <div className="text-sm text-text-secondary">Expected ROI</div>
        </div>
      </div>
    </div>
  );
};

export default ROICalculator;